// Scroll Float Animation from https://reactbits.dev/text-animations/scroll-float
import React, { useRef, useMemo } from 'react';
import { motion, useInView } from 'framer-motion';
import './ScrollFloat.css';

const ScrollFloat = ({
  children,
  className = '',
  scrollContainerRef,
  containerClassName = '',
  textClassName = '',
  animationDuration = 1,
  ease = 'easeOut',
  scrollStart = 'top bottom',
  scrollEnd = 'bottom top',
  stagger = 0.03
}) => {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { once: false, amount: 0.3 });

  // Split text into words
  const words = useMemo(() => {
    if (typeof children === 'string') {
      return children.split(' ');
    }
    return [children];
  }, [children]);

  return (
    <span ref={containerRef} className={`scroll-float-container ${containerClassName} ${className}`}>
      {words.map((word, wordIndex) => (
        <span key={wordIndex} className="scroll-float-word">
          {typeof word === 'string' ? (
            word.split('').map((char, charIndex) => {
              const index = wordIndex * 10 + charIndex;
              return (
                <motion.span
                  key={charIndex}
                  className={`scroll-float-char ${textClassName}`}
                  initial={{ y: 20, opacity: 0, filter: 'blur(8px)' }}
                  animate={isInView ? {
                    y: 0,
                    opacity: 1,
                    filter: 'blur(0px)'
                  } : {
                    y: 20,
                    opacity: 0,
                    filter: 'blur(8px)'
                  }}
                  transition={{
                    duration: animationDuration,
                    ease: ease,
                    delay: index * stagger,
                  }}
                >
                  {char}
                </motion.span>
              );
            })
          ) : (
            <motion.span
              className={`scroll-float-char ${textClassName}`}
              initial={{ y: 20, opacity: 0, filter: 'blur(8px)' }}
              animate={isInView ? {
                y: 0,
                opacity: 1,
                filter: 'blur(0px)'
              } : {
                y: 20,
                opacity: 0,
                filter: 'blur(8px)'
              }}
              transition={{
                duration: animationDuration,
                ease: ease,
                delay: wordIndex * stagger * 5,
              }}
            >
              {word}
            </motion.span>
          )}
          {wordIndex < words.length - 1 && (
            <span className="scroll-float-space">&nbsp;</span>
          )}
        </span>
      ))}
    </span>
  );
};

export default ScrollFloat;
